import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rdsFilterCb'
})
export class RdsFilterCbPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return null;
  }

}
